import WebDesign from './WebDesign.view';

export default WebDesign;
